import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class AboutV1 extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return <div className="ltn__about-us-area pt-120 pb-90 ">
			  <div className="container">
			    <div className="row flex-column-reverse flex-lg-row">
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-img-wrap about-img-left">
			          <img src={publicUrl+"assets/img/others/7.png"} alt="About Us Image" />
			          <div className="about-us-img-info about-us-img-info-2 about-us-img-info-3">
			            {/* <div className="ltn__video-img ltn__animation-pulse1">
			              <img src={publicUrl+"assets/img/others/8.png" } alt="video popup bg image" />
			              <a className="ltn__video-icon-2 ltn__video-icon-2-border---" href="https://www.youtube.com/embed/X7R-q9rsrtU?autoplay=1&showinfo=0" data-rel="lightcase:myCollection">
			                <i className="fa fa-play" />
			              </a>
			            </div> */}
			          </div>
			        </div>
			      </div>
			      <div className="col-lg-6 align-self-center">
			        <div className="about-us-info-wrap mb-20">
			          <div className="section-title-area ltn__section-title-2--- mb-20">
			            <h6 className="section-subtitle section-subtitle-2 ltn__secondary-color">About Us</h6>
			            <h1 className="section-title">The Trusted Plotted Land Developer in Karnataka<span>.</span></h1>
			            <p>Over 500+ plot buyers have trusted AVS across Karnataka for
						legally sound layouts, gated communities, and investor-ready land solutions.</p>
			          </div>
			          <ul className="ltn__list-item-half clearfix">
			            <li>
			              {/* <i className="flaticon-home-2" /> */}
						  <img src={publicUrl+"assets/img/icons/icon-img/Smart-Layout-Planning.svg"} alt="icon" style={{ borderRadius: '50%'}} />
			              Smart Layout Planning
			            </li>
			            <li>
			              {/* <i className="flaticon-mountain" /> */}
						  <img src={publicUrl+"assets/img/icons/icon-img/Nature-Rich-Surroundings.svg"} alt="icon" style={{ borderRadius: '50%'}} />
			              Nature-Rich Surroundings
			            </li>
			            <li>
			              {/* <i className="flaticon-heart" /> */}
						  <img src={publicUrl+"assets/img/icons/icon-img/Sustainable-Living-Features.svg"} alt="icon" style={{ borderRadius: '50%'}} />
			              Sustainable Living Features
			            </li>
			            <li>
			              {/* <i className="flaticon-secure" /> */}
						  <img src={publicUrl+"assets/img/icons/icon-img/Transparent-Legal-Process.svg"} alt="icon" style={{ borderRadius: '50%'}} />
			              Transparent Legal Process
			            </li>
			          </ul>
			          <div className="ltn__callout bg-overlay-theme-05  mt-30">
			            <p>"Building not just plots — but futures that grow in value.
			              " </p>
			          </div>
			          <div className="btn-wrapper animated go-top">
			            <Link to="/shop" className="theme-btn-1 btn btn-effect-1" style={{ borderRadius: '10px' }}>OUR PROJECTS</Link>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</div>
        }
}

export default AboutV1